// Provas de Síndromes Obstétricas (bloco 4 da turma C), do Guia do Estudante 2026/2
// (docs/horario/GUIA DO ESTUDANTE 20262.pdf, páginas 12–14). Só a turma C tem datas no guia.
// Cada prova acontece no horário da própria aula ("respectivos horários de cada turma"), então
// `replaces` aponta o código da aula daquele dia que vira prova; sem `group`, vale para C1–C4.
// Projeto em Equipe não tem data para a turma C ("-----") e o Ambulatório é só conceito.
const obstetriciaC = { type: 'exam', block: 4, syndrome: 'obstetricia', letter: 'C' };

export const period8Exams = {
  '2026-11-19': [
    { ...obstetriciaC, replaces: 'GT', title: 'Prova parcial', detail: 'GTs 1–3 e seminários 1–2', points: 30 },
  ],
  '2026-12-03': [
    { ...obstetriciaC, replaces: 'GT', title: 'Prova final', detail: 'GTs 1–6 e seminários 1–4', points: 45 },
    { ...obstetriciaC, replaces: 'TH', title: 'Prova de TH', detail: 'Treinamento de Habilidades', points: 50 },
    { ...obstetriciaC, replaces: 'PL', title: 'Prova de PL', detail: 'Prática de Laboratório', points: 50 },
  ],
};
